import {apiAxios} from "@/service/APIClient";
import GameDTO from "@/models/GameDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import PaginationDTO from "@/models/PaginationDTO";
import qs from "qs";

export const games = {
    list: async (pagination: PaginationDTO): Promise<PaginatedResponseDTO<GameDTO>> => {
        let resp = await apiAxios({
            url: `/games`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })

        return resp.data as PaginatedResponseDTO<GameDTO>
    },
    favorites: async (): Promise<GameDTO[]> => {
        let resp = await apiAxios({
            url: `/games/favorites`,
            method: 'GET'
        })

        return resp.data as GameDTO[]
    },
    hot: async (): Promise<GameDTO[]> => {
        let resp = await apiAxios({
            url: `/games/hot`,
            method: 'GET'
        })

        return resp.data as GameDTO[]
    },
    auth: async (id: number): Promise<any> => {
        let resp = await apiAxios({
            url: `/games/${id}/auth`,
            method: 'POST',
        })

        return resp.data as any
    },
    toggleFavorite: async (id: number, operation: string): Promise<GameDTO> => {
        let resp = await apiAxios({
            url: `/games/${id}/favorite/${operation}`,
            method: 'POST',
        })

        return resp.data as GameDTO
    },
}